export const plotsReducer = (state = {loading:true,result:null,plots:null,plot:null} , action) => {
    switch (action.type) {
        case 'PLOT_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'PLOTS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                plots: action.payload
            }
        case 'PLOT_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                plot: action.payload
            }
        case 'PLOTS_BY_FARM_SUCCESS':
            return {
                ...state,
                loading:false,
                plots: action.payload
            }
        case 'PLOT_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                plots: state.plots.filter(plot => plot._id !== action.payload.idPlot)
            }
        case 'PLOT_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'PLOT_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'PLOT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PLOT_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

